export default __webpack_public_path__ + "static/media/Self-Care Assessment worksheet.975acc29.pdf";